import { render, staticRenderFns } from "./ModuleUserConfig.vue?vue&type=template&id=61c9f508"
import script from "./ModuleUserConfig.vue?vue&type=script&lang=js"
export * from "./ModuleUserConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports